/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 */
export var ADD = "\ue63e";
export var ADD_COLUMN_LEFT = "\ue6f9";
export var ADD_COLUMN_RIGHT = "\ue6fa";
export var ADD_ROW_BOTTOM = "\ue6f8";
export var ADD_ROW_TOP = "\ue6f7";
export var ADD_TO_ARTIFACT = "\ue67c";
export var ADD_TO_FOLDER = "\ue6d2";
export var AIRPLANE = "\ue74b";
export var ALIGN_CENTER = "\ue603";
export var ALIGN_JUSTIFY = "\ue605";
export var ALIGN_LEFT = "\ue602";
export var ALIGN_RIGHT = "\ue604";
export var ALIGNMENT_BOTTOM = "\ue727";
export var ALIGNMENT_HORIZONTAL_CENTER = "\ue726";
export var ALIGNMENT_LEFT = "\ue722";
export var ALIGNMENT_RIGHT = "\ue724";
export var ALIGNMENT_TOP = "\ue725";
export var ALIGNMENT_VERTICAL_CENTER = "\ue723";
export var ANNOTATION = "\ue6f0";
export var APPLICATION = "\ue735";
export var APPLICATIONS = "\ue621";
export var ARROW_BOTTOM_LEFT = "\u2199";
export var ARROW_BOTTOM_RIGHT = "\u2198";
export var ARROW_DOWN = "\u2193 ";
export var ARROW_LEFT = "\u2190";
export var ARROW_RIGHT = "\u2192";
export var ARROW_TOP_LEFT = "\u2196";
export var ARROW_TOP_RIGHT = "\u2197";
export var ARROW_UP = "\u2191 ";
export var ARROWS_HORIZONTAL = "\u2194 ";
export var ARROWS_VERTICAL = "\u2195 ";
export var ASTERISK = "\u002a";
export var AUTOMATIC_UPDATES = "\ue65f";
export var BADGE = "\ue6e3";
export var BAN_CIRCLE = "\ue69d";
export var BANK_ACCOUNT = "\ue76f";
export var BARCODE = "\ue676";
export var BLANK = "\ue900";
export var BLOCKED_PERSON = "\ue768";
export var BOLD = "\ue606";
export var BOOK = "\ue6b8";
export var BOOKMARK = "\ue61a";
export var BOX = "\ue6bf";
export var BRIEFCASE = "\ue674";
export var BUILD = "\ue72d";
export var CALCULATOR = "\ue70b";
export var CALENDAR = "\ue62b";
export var CAMERA = "\ue69e";
export var CARET_DOWN = "\u2304";
export var CARET_LEFT = "\u2329";
export var CARET_RIGHT = "\u232A";
export var CARET_UP = "\u2303";
export var CELL_TOWER = "\ue770";
export var CHANGES = "\ue623";
export var CHART = "\ue67e";
export var CHAT = "\ue689";
export var CHEVRON_BACKWARD = "\ue6df";
export var CHEVRON_DOWN = "\ue697";
export var CHEVRON_FORWARD = "\ue6e0";
export var CHEVRON_LEFT = "\ue694";
export var CHEVRON_RIGHT = "\ue695";
export var CHEVRON_UP = "\ue696";
export var CIRCLE = "\ue66a";
export var CIRCLE_ARROW_DOWN = "\ue68e";
export var CIRCLE_ARROW_LEFT = "\ue68c";
export var CIRCLE_ARROW_RIGHT = "\ue68b";
export var CIRCLE_ARROW_UP = "\ue68d";
export var CITATION = "\ue61b";
export var CLIPBOARD = "\ue61d";
export var CLOUD = "\u2601";
export var CLOUD_DOWNLOAD = "\ue690";
export var CLOUD_UPLOAD = "\ue691";
export var CODE = "\ue661";
export var CODE_BLOCK = "\ue6c5";
export var COG = "\ue645";
export var COLLAPSE_ALL = "\ue763";
export var COLUMN_LAYOUT = "\ue6da";
export var COMMENT = "\ue68a";
export var COMPARISON = "\ue637";
export var COMPASS = "\ue79c";
export var COMPRESSED = "\ue6c0";
export var CONFIRM = "\ue639";
export var CONSOLE = "\ue79b";
export var CONTRAST = "\ue6cb";
export var CONTROL = "\ue67f";
export var CREDIT_CARD = "\ue649";
export var CROSS = "\u2717";
export var CURVED_RANGE_CHART = "\ue71b";
export var CUT = "\ue6ef";
export var DASHBOARD = "\ue751";
export var DATABASE = "\ue683";
export var DELETE = "\ue644";
export var DELTA = "\u0394";
export var DERIVE_COLUMN = "\ue739";
export var DESKTOP = "\ue6af";
export var DIRECTION_LEFT = "\ue681";
export var DIRECTION_RIGHT = "\ue682";
export var DISABLE = "\ue600";
export var DOCUMENT = "\ue630";
export var DOCUMENT_OPEN = "\ue71e";
export var DOCUMENT_SHARE = "\ue71f";
export var DOLLAR = "\u0024";
export var DOT = "\u2022";
export var DOUBLE_CARET_HORIZONTAL = "\ue6c7";
export var DOUBLE_CARET_VERTICAL = "\ue6c6";
export var DOUBLE_CHEVRON_DOWN = "\ue703";
export var DOUBLE_CHEVRON_LEFT = "\ue6ff";
export var DOUBLE_CHEVRON_RIGHT = "\ue701";
export var DOUBLE_CHEVRON_UP = "\ue702";
export var DOUGHNUT_CHART = "\ue6ce";
export var DOWNLOAD = "\ue62f";
export var DRAG_HANDLE_HORIZONTAL = "\ue716";
export var DRAG_HANDLE_VERTICAL = "\ue715";
export var DRAW = "\ue66b";
export var DRIVE_TIME = "\ue615";
export var DUPLICATE = "\ue69c";
export var EDIT = "\u270E";
export var EJECT = "\u23cf";
export var ENDORSED = "\ue75f";
export var ENVELOPE = "\u2709";
export var ERASER = "\ue773";
export var ERROR = "\ue648";
export var EURO = "\u20ac";
export var EXCHANGE = "\ue636";
export var EXCLUDE_ROW = "\ue6ea";
export var EXPAND_ALL = "\ue764";
export var EXPORT = "\ue633";
export var EYE_OFF = "\ue6cc";
export var EYE_ON = "\ue75a";
export var EYE_OPEN = "\ue66f";
export var FAST_BACKWARD = "\ue6a8";
export var FAST_FORWARD = "\ue6ac";
export var FEED = "\ue656";
export var FEED_SUBSCRIBED = "\ue78f";
export var FILM = "\ue6a1";
export var FILTER = "\ue638";
export var FILTER_KEEP = "\ue78c";
export var FILTER_LIST = "\ue6ee";
export var FILTER_REMOVE = "\ue78d";
export var FLAG = "\u2691";
export var FLAME = "\ue7a9";
export var FLASH = "\ue6b3";
export var FLOPPY_DISK = "\ue6b7";
export var FLOWS = "\ue659";
export var FOLDER_CLOSE = "\ue652";
export var FOLDER_NEW = "\ue7b0";
export var FOLDER_OPEN = "\ue651";
export var FOLDER_SHARED = "\ue653";
export var FOLDER_SHARED_OPEN = "\ue670";
export var FOLLOWER = "\ue760";
export var FOLLOWING = "\ue761";
export var FONT = "\ue6b4";
export var FORK = "\ue63a";
export var FORM = "\ue795";
export var FULL_CIRCLE = "\ue685";
export var FULL_STACKED_CHART = "\ue75e";
export var FULLSCREEN = "\ue699";
export var FUNCTION = "\ue6e5";
export var GANTT_CHART = "\ue6f4";
export var GEOLOCATION = "\ue640";
export var GEOSEARCH = "\ue613";
export var GIT_BRANCH = "\ue72a";
export var GIT_COMMIT = "\ue72b";
export var GIT_MERGE = "\ue729";
export var GIT_NEW_BRANCH = "\ue749";
export var GIT_PULL = "\ue728";
export var GIT_PUSH = "\ue72c";
export var GIT_REPO = "\ue748";
export var GLASS = "\ue6b1";
export var GLOBE = "\ue666";
export var GRAPH = "\ue673";
export var GRAPH_REMOVE = "\ue609";
export var GRID = "\ue6d0";
export var GRID_VIEW = "\ue6e4";
export var GROUP_OBJECTS = "\ue60a";
export var GROUPED_BAR_CHART = "\ue75d";
export var HAND = "\ue6de";
export var HAND_DOWN = "\ue6bb";
export var HAND_LEFT = "\ue6bc";
export var HAND_RIGHT = "\ue6b9";
export var HAND_UP = "\ue6ba";
export var HEADER = "\ue6b5";
export var HEADER_ONE = "\ue793";
export var HEADER_TWO = "\ue794";
export var HEADSET = "\ue6dc";
export var HEART = "\u2665";
export var HEART_BROKEN = "\ue7a2";
export var HEAT_GRID = "\ue6f3";
export var HEATMAP = "\ue614";
export var HELP = "\u003F";
export var HELPER_MANAGEMENT = "\ue66d";
export var HIGHLIGHT = "\ue6ed";
export var HISTORY = "\ue64a";
export var HOME = "\u2302";
export var HORIZONTAL_BAR_CHART = "\ue70c";
export var HORIZONTAL_BAR_CHART_ASC = "\ue75c";
export var HORIZONTAL_BAR_CHART_DESC = "\ue71d";
export var HORIZONTAL_DISTRIBUTION = "\ue720";
export var ID_NUMBER = "\ue771";
export var IMAGE_ROTATE_LEFT = "\ue73a";
export var IMAGE_ROTATE_RIGHT = "\ue73b";
export var IMPORT = "\ue632";
export var INBOX = "\ue629";
export var INFO_SIGN = "\u2139";
export var INNER_JOIN = "\ue7a3";
export var INSERT = "\ue66c";
export var INTERSECTION = "\ue765";
export var IP_ADDRESS = "\ue772";
export var ISSUE = "\ue774";
export var ISSUE_CLOSED = "\ue776";
export var ISSUE_NEW = "\ue775";
export var ITALIC = "\ue607";
export var JOIN_TABLE = "\ue738";
export var KEY = "\ue78e";
export var KEY_BACKSPACE = "\ue707";
export var KEY_COMMAND = "\ue705";
export var KEY_CONTROL = "\ue704";
export var KEY_DELETE = "\ue708";
export var KEY_ENTER = "\ue70a";
export var KEY_ESCAPE = "\ue709";
export var KEY_OPTION = "\ue742";
export var KEY_SHIFT = "\ue706";
export var KEY_TAB = "\ue757";
export var KNOWN_VEHICLE = "\ue73c";
export var LABEL = "\ue665";
export var LAYER = "\ue6cf";
export var LAYERS = "\ue618";
export var LAYOUT = "\ue60c";
export var LAYOUT_AUTO = "\ue60d";
export var LAYOUT_BALLOON = "\ue6d3";
export var LAYOUT_CIRCLE = "\ue60e";
export var LAYOUT_GRID = "\ue610";
export var LAYOUT_GROUP_BY = "\ue611";
export var LAYOUT_HIERARCHY = "\ue60f";
export var LAYOUT_LINEAR = "\ue6c3";
export var LAYOUT_SKEW_GRID = "\ue612";
export var LAYOUT_SORTED_CLUSTERS = "\ue6d4";
export var LEFT_JOIN = "\ue7a4";
export var LIGHTBULB = "\ue6b0";
export var LINK = "\ue62d";
export var LIST = "\u2630";
export var LIST_DETAIL_VIEW = "\ue743";
export var LOCATE = "\ue619";
export var LOCK = "\ue625";
export var LOG_IN = "\ue69a";
export var LOG_OUT = "\ue64c";
export var MANUAL = "\ue6f6";
export var MANUALLY_ENTERED_DATA = "\ue74a";
export var MAP = "\ue662";
export var MAP_CREATE = "\ue741";
export var MAP_MARKER = "\ue67d";
export var MAXIMIZE = "\ue635";
export var MEDIA = "\ue62c";
export var MENU = "\ue762";
export var MENU_CLOSED = "\ue655";
export var MENU_OPEN = "\ue654";
export var MERGE_COLUMNS = "\ue74f";
export var MERGE_LINKS = "\ue60b";
export var MINIMIZE = "\ue634";
export var MINUS = "\u2212";
export var MOBILE_PHONE = "\ue717";
export var MOBILE_VIDEO = "\ue69f";
export var MOON = "\ue754";
export var MORE = "\ue62a";
export var MOUNTAIN = "\ue7b1";
export var MOVE = "\ue693";
export var MUGSHOT = "\ue6db";
export var MULTI_SELECT = "\ue680";
export var MUSIC = "\ue6a6";
export var NEW_GRID_ITEM = "\ue747";
export var NEW_LINK = "\ue65c";
export var NEW_OBJECT = "\ue65d";
export var NEW_PERSON = "\ue6e9";
export var NEW_PRESCRIPTION = "\ue78b";
export var NEW_TEXT_BOX = "\ue65b";
export var NINJA = "\ue675";
export var NOTIFICATIONS = "\ue624";
export var NUMBERED_LIST = "\ue746";
export var NUMERICAL = "\ue756";
export var OFFICE = "\ue69b";
export var OFFLINE = "\ue67a";
export var OIL_FIELD = "\ue73f";
export var ONE_COLUMN = "\ue658";
export var OUTDATED = "\ue7a8";
export var PAGE_LAYOUT = "\ue660";
export var PANEL_STATS = "\ue777";
export var PANEL_TABLE = "\ue778";
export var PAPERCLIP = "\ue664";
export var PARAGRAPH = "\ue76c";
export var PATH = "\ue753";
export var PATH_SEARCH = "\ue65e";
export var PAUSE = "\ue6a9";
export var PEOPLE = "\ue63d";
export var PERCENTAGE = "\ue76a";
export var PERSON = "\ue63c";
export var PHONE = "\u260e";
export var PIE_CHART = "\ue684";
export var PIN = "\ue646";
export var PIVOT = "\ue6f1";
export var PIVOT_TABLE = "\ue6eb";
export var PLAY = "\ue6ab";
export var PLUS = "\u002b";
export var POLYGON_FILTER = "\ue6d1";
export var POWER = "\ue6d9";
export var PREDICTIVE_ANALYSIS = "\ue617";
export var PRESCRIPTION = "\ue78a";
export var PRESENTATION = "\ue687";
export var PRINT = "\u2399";
export var PROJECTS = "\ue622";
export var PROPERTIES = "\ue631";
export var PROPERTY = "\ue65a";
export var PUBLISH_FUNCTION = "\ue752";
export var PULSE = "\ue6e8";
export var RANDOM = "\ue698";
export var RECORD = "\ue6ae";
export var REDO = "\ue6c4";
export var REFRESH = "\ue643";
export var REGRESSION_CHART = "\ue758";
export var REMOVE = "\ue63f";
export var REMOVE_COLUMN = "\ue755";
export var REMOVE_COLUMN_LEFT = "\ue6fd";
export var REMOVE_COLUMN_RIGHT = "\ue6fe";
export var REMOVE_ROW_BOTTOM = "\ue6fc";
export var REMOVE_ROW_TOP = "\ue6fb";
export var REPEAT = "\ue692";
export var RESOLVE = "\ue672";
export var RIG = "\ue740";
export var RIGHT_JOIN = "\ue7a5";
export var RING = "\ue6f2";
export var ROTATE_DOCUMENT = "\ue6e1";
export var ROTATE_PAGE = "\ue6e2";
export var SATELLITE = "\ue76b";
export var SAVED = "\ue6b6";
export var SCATTER_PLOT = "\ue73e";
export var SEARCH = "\ue64b";
export var SEARCH_AROUND = "\ue608";
export var SEARCH_TEMPLATE = "\ue628";
export var SEARCH_TEXT = "\ue663";
export var SEGMENTED_CONTROL = "\ue6ec";
export var SELECT = "\ue616";
export var SELECTION = "\u29bf";
export var SEND_TO = "\ue66e";
export var SEND_TO_GRAPH = "\ue736";
export var SEND_TO_MAP = "\ue737";
export var SERIES_ADD = "\ue796";
export var SERIES_CONFIGURATION = "\ue79a";
export var SERIES_DERIVED = "\ue799";
export var SERIES_FILTERED = "\ue798";
export var SERIES_SEARCH = "\ue797";
export var SETTINGS = "\ue6a2";
export var SHARE = "\ue62e";
export var SHOP = "\ue6c2";
export var SHOPPING_CART = "\ue6c1";
export var SIM_CARD = "\ue718";
export var SLASH = "\ue769";
export var SMALL_CROSS = "\ue6d7";
export var SMALL_MINUS = "\ue70e";
export var SMALL_PLUS = "\ue70d";
export var SMALL_TICK = "\ue6d8";
export var SOCIAL_MEDIA = "\ue671";
export var SORT = "\ue64f";
export var SORT_ALPHABETICAL = "\ue64d";
export var SORT_ALPHABETICAL_DESC = "\ue6c8";
export var SORT_ASC = "\ue6d5";
export var SORT_DESC = "\ue6d6";
export var SORT_NUMERICAL = "\ue64e";
export var SORT_NUMERICAL_DESC = "\ue6c9";
export var SPLIT_COLUMNS = "\ue750";
export var SQUARE = "\ue686";
export var STACKED_CHART = "\ue6e7";
export var STAR = "\u2605";
export var STAR_EMPTY = "\u2606";
export var STEP_BACKWARD = "\ue6a7";
export var STEP_CHART = "\ue70f";
export var STEP_FORWARD = "\ue6ad";
export var STOP = "\ue6aa";
export var STRIKETHROUGH = "\ue7a6";
export var STYLE = "\ue601";
export var SWAP_HORIZONTAL = "\ue745";
export var SWAP_VERTICAL = "\ue744";
export var SYMBOL_CIRCLE = "\ue72e";
export var SYMBOL_CROSS = "\ue731";
export var SYMBOL_DIAMOND = "\ue730";
export var SYMBOL_SQUARE = "\ue72f";
export var SYMBOL_TRIANGLE_DOWN = "\ue733";
export var SYMBOL_TRIANGLE_UP = "\ue732";
export var TAG = "\ue61c";
export var TAKE_ACTION = "\ue6ca";
export var TAXI = "\ue79e";
export var TEXT_HIGHLIGHT = "\ue6dd";
export var TH = "\ue667";
export var TH_DERIVED = "\ue669";
export var TH_LIST = "\ue668";
export var THUMBS_DOWN = "\ue6be";
export var THUMBS_UP = "\ue6bd";
export var TICK = "\u2713";
export var TICK_CIRCLE = "\ue779";
export var TIME = "\u23F2";
export var TIMELINE_AREA_CHART = "\ue6cd";
export var TIMELINE_BAR_CHART = "\ue620";
export var TIMELINE_EVENTS = "\ue61e";
export var TIMELINE_LINE_CHART = "\ue61f";
export var TINT = "\ue6b2";
export var TORCH = "\ue677";
export var TRAIN = "\ue79f";
export var TRANSLATE = "\ue759";
export var TRASH = "\ue63b";
export var TRENDING_DOWN = "\ue71a";
export var TRENDING_UP = "\ue719";
export var TWO_COLUMNS = "\ue657";
export var UNDERLINE = "\u2381";
export var UNDO = "\u238c";
export var UNGROUP_OBJECTS = "\ue688";
export var UNKNOWN_VEHICLE = "\ue73d";
export var UNLOCK = "\ue626";
export var UNPIN = "\ue650";
export var UNRESOLVE = "\ue679";
export var UPDATED = "\ue7a7";
export var UPLOAD = "\ue68f";
export var USER = "\ue627";
export var VARIABLE = "\ue6f5";
export var VERTICAL_BAR_CHART_ASC = "\ue75b";
export var VERTICAL_BAR_CHART_DESC = "\ue71c";
export var VERTICAL_DISTRIBUTION = "\ue721";
export var VIDEO = "\ue6a0";
export var VOLUME_DOWN = "\ue6a4";
export var VOLUME_OFF = "\ue6a3";
export var VOLUME_UP = "\ue6a5";
export var WALK = "\ue79d";
export var WARNING_SIGN = "\ue647";
export var WATERFALL_CHART = "\ue6e6";
export var WIDGET = "\ue678";
export var WIDGET_BUTTON = "\ue790";
export var WIDGET_FOOTER = "\ue792";
export var WIDGET_HEADER = "\ue791";
export var WRENCH = "\ue734";
export var ZOOM_IN = "\ue641";
export var ZOOM_OUT = "\ue642";
export var ZOOM_TO_FIT = "\ue67b";
